import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { BoxHead, Underline } from "../../../Components/Styles/PageStyles";

import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../../Config";
import Loading from "../../../Components/Loading";
import NotFoundModel from "../../../Components/NotFoundModel";
import { Add, AddBtn } from "../../../Components/Styles/InputStyles";
import Table from "../../../Components/CoOccupant/Table";
import { toast } from "react-toastify";
import SideModal from "../../../Components/SideModal";
import AddCoOccupant from "../../../Components/CoOccupant/AddCoOccupant";
import EditCoOccupant from "../../../Components/CoOccupant/EditCoOccupant";
import DeleteCoOccupant from "../../../Components/CoOccupant/Delete";

const CoOccupant = ({ tenantId }) => {
  const user = useSelector((state) => state.UserReducer.user);
  const [apiData, setApiData] = useState([]);
  const [coOccupantAdd, setCoOccupantAdd] = useState(false);
  const [coOccupantEdit, setCoOccupantEdit] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [isDeleteCoOccupant, setIsDeleteCoOccupant] = useState(false);

  let query = `&id=${tenantId}`;
  const fetchFunction = async () => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/co-occupant/list/${tenantId}`,
      {
        headers: {
          authorization: "Bearer " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };
  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
    }
  };

  const getError = (res) => {};

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => {
      clearTimeout(handler);
    };
  }, []);
  //----------------Add CO-Occupant------------------------
  const addCoOccupantFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/co-occupant/add`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddCoOccupantSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setCoOccupantAdd(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddCoOccupantError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addCoOccupantLoading, mutate: addCoOccupantMutate } =
    useMutation(addCoOccupantFunction, {
      onSuccess: onAddCoOccupantSuccess,
      onError: onAddCoOccupantError,
    });

  //-------Edit Co-Occupant-----------------------------------
  const editCoOccupantFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/co-occupant/edit`, values, {
      headers: {
        authorization: `Bearer ${user.token}`,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditCoOccupantSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setCoOccupantEdit(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditCoOccupantError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editCoOccupantLoading, mutate: editCoOccupantMutate } =
    useMutation(editCoOccupantFunction, {
      onSuccess: onEditCoOccupantSuccess,
      onError: onEditCoOccupantError,
    });

  //----------Delete Co-Occupant-----------------------------------
  const deleteCoOccupantFunction = async (id) => {
    return await axios.post(`${Config.apiUrl}/tenant/co-occupant/delete/${id}`, {}, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const deleteCoOccupantSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsDeleteCoOccupant(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const deleteCoOccupantError = (data) => {
    setIsDeleteCoOccupant(false);
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteCoOcupantLoading, mutate: deleteCoOccupantMutate } =
    useMutation(deleteCoOccupantFunction, {
      onSuccess: deleteCoOccupantSuccess,
      onError: deleteCoOccupantError,
    });

  const handleCoOccupantClose = () => {
    setIsDeleteCoOccupant(false);
  };

  return (
    <>
      <Wrapper>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Co-Occupant
            <Underline />
          </BoxTitle>
          <Add type="button" onClick={() => setCoOccupantAdd(true)} className="mb-1">
            Add Co-Occupant
          </Add>
        </BoxHead>
        {!error && !isLoading && apiData && (
          <TableWrapper>
            <Table
              apiData={error ? [] : apiData}
              setSelectedData={setSelectedData}
              setCoOccupantEdit={setCoOccupantEdit}
              setIsDeleteCoOccupant={setIsDeleteCoOccupant}
            />
            {(error || (apiData && apiData.length === 0)) && !isLoading && (
              <NotFoundModel />
            )}
          </TableWrapper>
        )}
        {(isLoading || isRefetching) && <Loading />}
      </Wrapper>
      <SideModal isOpen={coOccupantAdd} onClose={() => setCoOccupantAdd(false)}>
        <AddCoOccupant
          addCoOccupantLoading={addCoOccupantLoading}
          addCoOccupantMutate={addCoOccupantMutate}
          setCoOccupantAdd={setCoOccupantAdd}
          tenantId={tenantId}
        />
      </SideModal>

      <SideModal
        isOpen={coOccupantEdit}
        onClose={() => setCoOccupantEdit(false)}
      >
        <EditCoOccupant
          editCoOccupantLoading={editCoOccupantLoading}
          editCoOccupantMutate={editCoOccupantMutate}
          setCoOccupantEdit={setCoOccupantEdit}
          selectedData={selectedData}
          tenantId={tenantId}
        />
      </SideModal>

      {isDeleteCoOccupant && (
          <DeleteCoOccupant
            setIsDeleteCoOccupant={setIsDeleteCoOccupant}
            selectedData={selectedData}
            deleteCoOcupantLoading={deleteCoOcupantLoading}
            deleteCoOccupantMutate={deleteCoOccupantMutate}
            handleClose={handleCoOccupantClose}
          />
        )}
    </>
  );
};

const Wrapper = tw.div`space-y-4 mt-2`;
const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;
export const BoxTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;

export default CoOccupant;
